<button type="button" class="btn btn-primary" i18n="pulsante filtri" data-toggle="collapse" [attr.href]="'#'+ref" (click)="collapsed = !collapsed">{{label}} <i class="fas fa-chevron-down" [ngClass]="getChevronClass()"></i></button>
